import { Capture } from "@cleeng/mediastore-sdk";
import React from "react";
import { useNavigate, useLocation } from "react-router-dom";

function CapturePage() {
  const navigate = useNavigate();
  const { search } = useLocation();
  const query = new URLSearchParams(search);
  const offerId = query.get("offerId");
  const couponCode = query.get("couponCode");

  const handleNavigate = () => {
    if (couponCode && offerId) {
      navigate(`/checkout?offerId=${offerId}&couponCode=${couponCode}`)
    } else if (localStorage.getItem('save_redirect_url')) {
      const redirectUrl = localStorage.getItem('save_redirect_url');
      localStorage.removeItem('save_redirect_url');
      navigate(redirectUrl);
    } else {
      navigate("/choose-plan")
    };
  };

  return (
    <Capture
      onSuccess={handleNavigate}
    />
  );
}

export default CapturePage;
